
<div class="pg-index stop-swiping">
  <div class="main-swiper swiper-container">
    <div class="swiper-wrapper" ref="wrapper">
      <!-- p1 -->
      <div class="swiper-slide p1">
        <!-- <div class="logo"></div> -->
        <div class="btn-wrap">
          <div class="times">剩余抽奖次数:<span class="emphsis">{{chance}}</span></div>
          <div class="draw" @click="lotto"></div>
        </div>
        <div class="btn-wrap btn-wrap-2">
          <div class="times times-call">召集<span class="emphsis">1位</span>兄弟,增加<span class="emphsis">1次</span>抽奖机会</div>
          <div class="call" @click="callFriend"></div>
          <!-- <div class="call-times">还可以召集{{userInfo.weixin_state ? userInfo.invitablenum : 4}}名兄弟</div> -->
        </div>
        <div class="lucky">
          <autoScroll :list.sync="luckyList" :config="config">
            <template v-slot="vData">
              <!-- 数据渲染列表 -->
              <li v-for="(item, index) in vData.vDota" :key="index" class="iztVnode-item" :style="{ height: vData.config.itemHeight + 'px',lineHeight: vData.config.itemHeight + 'px' }">
                <span class="lucky-name">{{item.nickname}}</span>&nbsp;&nbsp;已抽到&nbsp;&nbsp;<span class="lucky-prize">{{item.item_name}}</span>
              </li>
            <!-- 数据渲染列表 -->
            </template>
          </autoScroll>
        </div>
        <div class="frame">
          <div class="frame-bg">
            <div class="frame-title"></div>
            <div class="prize-wrapper swiper-container prize-swiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide frame-slide"  v-for="(item, index) in prize" :key="index">
                  <Prize v-for="(prize, pIndex) in item" :key="pIndex" :prize="prize.icon" :name="prize.name"></Prize>
                </div>
              </div>
            </div>
            <div class="swiper-pagination prize-pagination">
              <div
                class="swiper-pagination-bullet"
                :class="[
                  prizeSwiper.activeIndex === index ? 'swiper-pagination-bullet-active' : ''
                ]"
                v-for="(item, index) in bullets"
                :key="index"
                @click="prizeSwiper.slideTo(index, 600, 0)"
              >
                <div :class="`swiper-pagination-bullet-${index + 1}`"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="slide-prev" @click="slidePrev"></div>
        <div class="slide-prev next" @click="slideNext"></div>
      </div>
      <!-- p2 -->
      <div class="swiper-slide p2" ref="p2">
        <div
          class="get"
          :class="{disabled: !prizeList.list || prizeList.list.some(x => x.state) && userInfo.charname}"
          @click="getPrize"
        ></div>
        <div class="bind" :class="{disabled: userInfo.isbind}" @click="bindRole"></div>
        <div v-if="userInfo.isbind" class="role">
          <span class="role-title">已绑定角色：</span>
          <span class="role-name">{{userInfo.charname}}</span>
        </div>
        <Frame class="big-frame" :style="{height: (prizeHeight + 32)/100 + 'rem'}">
          <div v-if="!prizeList.list || !prizeList.list.length" class="none">暂无奖励</div>
          <div v-else class="desc">点击图标，<span style="color: #c21000">选择10种</span>想要领取的奖励</div>
          <div class="prize-wrapper">
            <Prize
              v-for="(prize, index) in prizeList.list"
              :key="index"
              :prize="prize.icon"
              :name="prize.title"
              :drawed="prize.state"
              :id="prize.id"
              :choosed="myPrize.length ? myPrize.some(x => x.id === prize.id) : false"
              :can-draw="!prize.state && prizeList.list && !prizeList.list.some(x => x.state) && myPrize.length < 10"
              @toggle="togglePrize"
            >
            </Prize>
          </div>
        </Frame>
      </div>
      <!-- p3 -->
      <div class="swiper-slide p3">
        <div class="rule-title"></div>
        <Frame class="big-frame">
          <div class="rule-wrapper">
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">活动时间：2022年12月14日~2022年12月17日</div>
            </div>
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">
                <span class="emphasis">十连抽奖：</span><br>奖励均为《原始征途》游戏内道具，从页面公示的奖池中抽取，品质由高到低为紫、绿、黄、蓝，抽出概率递减。
              </div>
            </div>
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">
                <span class="emphasis">召集助力：</span><br>
                <span>
                  1、默认有一次十连抽机会，还可召集兄弟助力增加机会；将页面分享给好友即可发起召集，好友助力成功后，便可增加一次10连抽的机会，最多可以额外增加4次。
                </span><br>
                <span>2、每位玩家仅有一次为好友助力的机会，受邀完成一次助力之后，将无法再为其他玩家进行助力。</span>
              </div>
            </div>
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">
                <span class="emphasis">绑定角色：</span><br>
                领取奖励前，玩家需要通过登录巨人通行证绑定《原始征途》终极测试区中的已创建角色；本次活动仅面向终极测试区服，并且首次绑定后将无法换绑。
              </div>
            </div>
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">
                <span class="emphasis">奖励领取：</span><br>
                <span>
                  1、可以在”我的奖励“界面中查看已经抽到的奖励，并且从已经抽到的奖励任意选择10个奖励领取到游戏中。
                </span><br>
                <span>2、活动期间，玩家只能领取一次奖励，领取的奖励数量必须为10个。</span>
              </div>
            </div>
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">
                <span class="emphasis">奖励发放：</span><br>
                领奖后，奖励将以自动发放至玩家绑定的《原始征途》角色账号之中，需自行前往查收。
              </div>
            </div>
            <div class="rule">
              <div class="rule-seq"></div>
              <div class="rule-content">
                <span class="emphasis">注意事项：</span><br>
                <span>
                  1、如使用外挂等不正当方式参加本活动的，官方将有权取消用户参与及获奖资格。
                </span><br>
                <span>2、如有任何问题，请联系《原始征途》手游官方客服，客服电话021-61205656。</span>
              </div>
            </div>
          </div>
        </Frame>
      </div>
    </div>
  </div>
  <div class="header">
    <div class="game_icon"></div>
    <div class="game_button fr">
      <a href="/index.shtml"></a>
      <a v-if="!ingame" href="javascript:;" class="downloadbtn ios" target="_self" @click="iosHandler"></a>
      <a href="javascript:;" class="downloadbtn android" target="_self" @click="downloadHandler"></a>
    </div>
  </div>
  <div class="slogan"></div>
  <!-- <div class="login">
    <span v-if="!userInfo || !userInfo.weixin_state">亲爱的用户, 请 <a class="link" @click="checkLoginStatus">登录</a></span>
    <span v-else>欢迎您 <span class="name">{{userInfo.shareinfo.nickname}}</span></span>
  </div> -->
  <div class="swiper-pagination main-pagination">
    <div
      class="swiper-pagination-bullet"
      :class="[
        `swiper-pagination-bullet-${index + 1}`,
        activeIndex === index ? 'active' : ''
      ]"
      v-for="(item, index) in bullets"
      :key="index"
      @click="slideTo(index)"
    >
    </div>
  </div>
</div>
